import { version } from 'swiper/package.json';

// Swiper is self-hosted and loaded on demand instead of being bundled, so it never ships as part of
// site.js or the Angular web-components bundle. The file is copied out of node_modules to
// js/vendor/swiper/ by schu-style/copy-vendor.mjs (part of `nx build schu-style` and `nx serve schu-style`).
// The package version is only used as a cache-busting query string, so it tracks upgrades automatically.
// NOTE: Swiper's custom elements inject their own styles, so no separate stylesheet is needed.
const SCRIPT_URL = `/js/vendor/swiper/swiper-element-bundle.min.js?v=${version}`;

let loading = false;

function loadSwiper()
{
  if (loading) return;
  loading = true;

  const script = document.createElement('script');
  script.src = SCRIPT_URL;
  script.defer = true;
  script.onerror = () => console.error('[swiper] failed to load', SCRIPT_URL);
  document.head.appendChild(script);
}

/**
 * Loads Swiper's custom elements the first time a swiper-container shows up in the DOM -- whether it's
 * already there at call time, or added later (e.g. client-side rendered content).
 */
export function loadSwiperWhenNeeded(root = document)
{
  if (root.querySelector('swiper-container'))
  {
    loadSwiper();
    return;
  }

  const observer = new MutationObserver(() =>
  {
    if (root.querySelector('swiper-container'))
    {
      observer.disconnect();
      loadSwiper();
    }
  });

  observer.observe(document.body, { subtree: true, childList: true });
}
